module.exports = __webpack_public_path__ + "static/media/step-background.bf63d92a.png";